/*
 * @Author: liujunhong
 * @Date: 2023/6/27
 * @Desc: 游戏内扫码
 */


import QRCode from 'qrcode.react';
import AliLogo from '../../images/ali.png'

const Index = () => {

  const href = window.location.href
  const url = new URL(href);
  const params = new URLSearchParams(url.search);
  const qrcode = params.get('qrcode');

  return <div style={{
    overflow: 'hidden',
  }}>
    <div style={{
      margin: '17px',
    }}>
      <QRCode
        id="pay_qr_code"
        value={qrcode}
        fgColor="#000"
        level="Q"
        style={{
          margin: '0 auto',
          width: '100%',
          height: 'auto',
          display: 'flex'
        }}
        imageSettings={{
          src: AliLogo,
          height: 36,
          width: 36,
          excavate: true,
        }}

      />
    </div>
  </div>
}

export default Index
